require('/opt/odin/app/frontend/pages/contests/index/components/card/index.module.scss');module.exports = "../../app/cells/pages/contests/index/card/show.erb";